import cloneDeep from 'lodash/cloneDeep';
import resizedDasWebUri, {modes, presetDimensions} from 'components/imaging/ResizedDasWebImage';

export const withSelectedImageUri = (property) => {
  const p = cloneDeep(property);
  if (p.propertyPhotoList && p.propertyPhotoList.length > 0) {
    let selectedIndex = p.propertyPhotoUriSelectedIndex || 0;
    if (selectedIndex >= p.propertyPhotoList.length) {
      selectedIndex = 0;
    }
    const selectedPhoto = p.propertyPhotoList[selectedIndex].replace(/\s/g, '%20');
    p.propertyPhotoUri = resizedDasWebUri({
      uri: selectedPhoto,
      mode: modes.EXACT,
      resizeDimensions: presetDimensions.LARGE,
    });
  }
  return p;
};